jQuery(($) => {
    const $masonry = $('.masonry');

    if ($masonry.length) {
        require.ensure([], require => {
            require([
                'imagesloaded',
                'jquery-bridget',
                'masonry-layout',
            ], (imagesLoaded, jQueryBridget, Masonry) => {
                // init jQuery on imageloaded
                imagesLoaded.makeJQueryPlugin($);

                // make Masonry a jQuery plugin
                jQueryBridget('masonry', Masonry, $);

                // loop over all our masonry blocks and init them
                $masonry.each(function (i, container) {
                    let $container = $(container);

                    $container.imagesLoaded(function () {
                        $container.masonry({
                            columnWidth: '.masonry__sizer',
                            itemSelector: '.masonry__item',
                            percentPosition: true
                        });
                    });
                });
            });
        }, 'masonry');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/layouts/masonry.js